const Bar = props => <span className={`bar-wrapper ${props.className || ""}`}>
    <span className="bar-fill" style={{ background: "#fbb03b", width: `${props.persentage}%` }} />
</span>

export default Bar;